enum GridAction {
  Selecting,
  ResizingRange,
  ClickCell,
  None,
}

export default GridAction;
